import {
  TableBody,
  TableRow,
  TableCell,
  Toolbar,
  InputAdornment,
  TextField,
} from '@mui/material'
import { makeStyles } from '@material-ui/core'
import { Search } from '@mui/icons-material'

import useTable from '../UI/Table'

import { useState } from 'react'
import { usePlaces } from '../../services/places'

const headCells = [
  { id: 'nombre', label: 'Nombre' },
  { id: 'zona', label: 'Zona' },
]

const useStyles = makeStyles(() => ({
  textField: {
    width: '100%',
    outline: '0',
    marginBottom: '20px',
    borderRadius: '20px',
    border: '0',
    backgroundColor: '#e9e9e9',
    fontSize: '14px',
    appearance: 'none',
    resize: 'none',
    padding: '2px',
  },
  input: {
    border: 'none',
    height: '2rem',
  },
  iconButton: {
    width: '2rem',
    height: '2rem',
    marginRight: '-10px',
  },
  selectButton: {
    backgroundColor: '#00544e',
    color: 'white',
    height: '30px',
    width: '30px',
    transition: '0.3s all ease',
    '&:hover': {
      backgroundColor: '#009696',
      border: '1px solid #00544e',
    },
  },
  searchInput: {
    width: '100%',
    marginRight: '5%',
  },
}))

export const PlaceSelect = ({ setPlace, setOpenPopup, setTime, unidad }) => {
  const [places] = usePlaces()

  const classes = useStyles()

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items
    },
  })

  const { TblContainer, TblHead, TblPagination, recordAfterPagingAndSorting } =
    useTable(places, headCells, filterFn)

  const handleSearch = ({ target }) => {
    const { value } = target
    setFilterFn({
      fn: (items) => {
        if (target.value === '') return items
        else
          return items.filter((x) =>
            x.nombre.toLowerCase().includes(value.toLowerCase())
          )
      },
    })
  }

  return (
    <>
      <div style={{ marginTop: '15px', marginBottom: '30px' }}>
        <Toolbar>
          <div className="special-group">
            <TextField
              variant="standard"
              className={classes.searchInput}
              sx={{
                height: '40px',
                borderRadius: '25px',
                backgroundColor: '#e9e9e9',
                fontSize: '14px',
                padding: '5px',
              }}
              placeholder="Buscar Lugar"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ marginLeft: '10px' }}>
                    <Search />
                  </InputAdornment>
                ),
                disableUnderline: true,
              }}
              onChange={handleSearch}
            />
          </div>
        </Toolbar>
        <TblContainer>
          <TblHead />
          <TableBody>
            {recordAfterPagingAndSorting().map((place) => (
              <TableRow
                key={place.id}
                onClick={() => {
                  setPlace(place.nombre)
                  let newTime
                  if (
                    unidad === 'Nissan 2014' ||
                    unidad === 'Camioneta Ford' ||
                    unidad === 'Recogen (Camioneta)'
                  ) {
                    newTime = place.tiempoDoble
                  } else if (
                    unidad === 'International' ||
                    unidad === 'Camión Ford' ||
                    unidad === 'Kenworth 10' ||
                    unidad === 'Recogen (Camion)'
                  ) {
                    newTime = place.tiempoCamion
                  } else if (
                    unidad === 'Kenworth' ||
                    unidad === 'Kenworth 18' ||
                    unidad === 'Recogen (Torton)'
                  ) {
                    newTime = place.tiempoTorton
                  }
                  setTime(newTime)
                  setOpenPopup(false)
                }}
              >
                <TableCell data-label="Nombre: ">{place.nombre}</TableCell>
                <TableCell data-label="Zona: ">{place.zona}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </TblContainer>
        <TblPagination />
      </div>
    </>
  )
}
